import React from 'react'
import ChooseYourPlan from '../../pages/ChooseYourPlan'

function Planbill() {
  return (
    <div className='w-full bg-[#111827] mx-auto'>
  <ChooseYourPlan/>
    </div>
  )
}

export default Planbill